// extracted by mini-css-extract-plugin
export var arrow = "transition-week-switcher-module--arrow--016f5";
export var container = "transition-week-switcher-module--container--b0e4c";
export var navButton = "transition-week-switcher-module--nav-button--efbd8";
export var prev = "transition-week-switcher-module--prev--2848f";
export var preview = "transition-week-switcher-module--preview--f40db";